import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import theme from './Blocker.scss';

/**
 * Component to block any component for some time
 */
class Blocker extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    time: PropTypes.number.isRequired,
    onUnblock: PropTypes.func,
  };
  static defaultProps = {
    onUnblock: noop,
  };

  constructor(props) {
    super(props);

    this.state = {
      blocked: true,
      timePassed: 0,
    };
  }

  componentDidMount() {
    this.timer = setInterval(this.tick, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  tick = () => {
    if (this.state.timePassed !== this.props.time) {
      this.setState((prevState) => ({ timePassed: prevState.timePassed + 1 }));
    } else {
      this.setState({ blocked: false }, this.props.onUnblock);
    }
  };

  render() {
    const { children } = this.props;

    return (
      <div className={ theme.root }>

        {this.state.blocked && <div className={ theme.screen } />}
        {
          this.state.blocked && (
            <div className={ theme.timer }>
              {this.props.time - this.state.timePassed}
            </div>
          )
        }
        { children }
      </div>
    );
  }
}

export default Blocker;
